// extracted by mini-css-extract-plugin
export default {"container":"navbar_container__VPgXu","tabContainer":"navbar_tabContainer__kV4VD"};